import { render } from "./OltSelector.vue?vue&type=template&id=74b1d28a&scoped=true"
import script from "./OltSelector.vue?vue&type=script&lang=js"
export * from "./OltSelector.vue?vue&type=script&lang=js"

import "./OltSelector.vue?vue&type=style&index=0&id=74b1d28a&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b1d28a"]])

export default __exports__